import { formatDate, Location } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import {
  FormControl,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {
  getDistanceUsingHaversine,
  getFormattedDate,
  getFormattedDateTime,
  getFormattedTime,
  getStartEndDateTime,
  getWelfareCheckInterval,
  isLargeScreen,
} from '../../../../../global.variable';
import { AppService } from '../../../../app.service';
import { ConfirmDialogComponent } from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { DataCheckService } from '../../../../shared/services/data-check.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ClientsService } from '../../clients/clients.service';
import { PagesService } from '../../pages.service';
import { JobsService } from '../jobs.service';

import { Capacitor } from '@capacitor/core';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { AddCheckpointRouteComponent } from '../../../../shared/components/add-checkpoint-route/add-checkpoint-route.component';
import { ChangeScheduleComponent } from '../../../../shared/components/change-schedule/change-schedule.component';
import { ClockInOutComponent } from '../../../../shared/components/clock-in-out/clock-in-out.component';
import { ContactComponent } from '../../../../shared/components/contact/contact.component';
import { FileUploadComponent } from '../../../../shared/components/file-upload/file-upload.component';
import { MediaPreviewComponent } from '../../../../shared/components/media-preview/media-preview.component';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { PrompterComponent } from '../../../../shared/components/prompter/prompter.component';
import { ScanCheckpointComponent } from '../../../../shared/components/scan-checkpoint/scan-checkpoint.component';
import { ViewUserDetailComponent } from '../../../../shared/components/view-user-detail/view-user-detail.component';
import { gTDB } from '../../../../shared/services/db';
import { DeviceInfoService } from '../../../../shared/services/device-info.service';
import { NativeBgUploadService } from '../../../../shared/services/native-bg-upload.service';
import { SqliteDbService } from '../../../../shared/services/sqlite-db.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { WebSocketService } from '../../../../shared/services/web-socket.service';
import { RosterShiftsService } from '../../roster-shifts/roster-shifts.service';
import { UsersService } from '../../users/users.service';

@Component({
  selector: 'gtapp-job-details',
  templateUrl: './job-details.component.html',
  styleUrl: './job-details.component.scss',
  standalone: false,
})
export class JobDetailsComponent implements OnInit, OnDestroy {
  jobDetailData: any;
  jobHistoryData: any = [];
  jobCommentsFilesStatusData: any = [];
  jobCheckpointListData: any = [];

  loggedInUpdatesSet = new Set<string>();

  jobStatusesListData: any = [];
  availableStatusesListData: any = [];

  scannedCheckpointCount: number = 0;
  showUpdateFutureShifts: boolean = false;

  cancelReasonData: any = {};

  updatedJobExtraInfo: any;
  cancelReason: any;

  largeView: Boolean = isLargeScreen;

  jobDetailsTableView: any = [
    {
      header: 'Date / Update By',

      sortKey: 'updated_datetime',
      dateRangeKey: 'updated_datetime',
      sortOrder: 'desc',
      datetimeObj: true,
      nestedValue: (row: any) => {
        return row?.updated_datetime || row?.updated_at;
      },
      suffixNestedValue: (row: any) => {
        return `\n${row?.user_name}`;
      },

      tableColumnStyle: {
        'white-space': 'pre-line',
      },
    },

    {
      header: 'Update',
      name: 'action',
      sortKey: 'action',
      searchKey: 'action',
      sortOrder: 'desc',
    },
  ];

  otherParams: any = {
    tableRowStyle: (rowData: any) => {
      if (rowData?.is_deleted || this.isItemNotShownInReport(rowData)) {
        return {
          opacity: '0.6',
        };
      }
      return {};
    },
  };

  selectedEvent: any;
  selectedEventId: string = ''; // for re opening after any update to the event

  isAdmin: boolean = false;
  isDispatchUser: boolean = false;
  subscriberUserId: string = '';

  siteContactList: any;

  selectedJobStatus: any;
  selectedStatus: any = 1;

  messageChannel = new MessageChannel();
  fetchingDataFromServer: boolean = false;
  offlineMode: boolean = false;

  hasScheduleStarted: boolean = false;

  monitoringCompanyList: any = [];

  mcInputValue: any;

  externalNewJobId: any;
  externalOldJobId: any;

  oldShiftPositionValue: any;
  newShiftPositionValue: any;

  todayDate: any = new Date();

  onsiteIntervalFn: any;
  onsiteTimeOutFn: any;
  onsiteTimer = '00:00:00';

  onsiteTime: any;
  dateTimeValue: any;

  scheduleCheck: boolean = true;

  onsiteVisibilityChangeHandler: any;
  alarmResposneReceivedVisibilityChangeHandler: any;

  scheduleDuration: any;
  intervalData: any = [];
  welfareReminderDict: any = {};
  selectedInterval: any;

  canScheduleBeUpdated: boolean = false;
  isCurrentORFutureSchedule: boolean = false;
  showWelfareItem: boolean = true;

  changeSortOrder: boolean = false;

  schedulerForm: UntypedFormGroup = new UntypedFormGroup({
    end_time: new FormControl(null),
    start_time: new FormControl(null),
    start_day: new FormControl(null),
    end_day: new FormControl(null, Validators.required),
    repeat_times: new UntypedFormControl(null),
    repeat_type: new UntypedFormControl(null, Validators.required),
    repeat_details: new UntypedFormControl([]),
    repeat_interval: new UntypedFormControl(1, [
      Validators.required,
      Validators.pattern('^[0-9]*$'),
    ]),
    position: new UntypedFormControl(null, []),
    week_day: new UntypedFormControl(null, []),
    month_repeat_case: new UntypedFormControl(null, []),
  });

  lastStatus: any;
  bottomSectionFixedHeight: string = '198 px';

  statusDropdownOpen: boolean = false;

  dialogRef: any;

  endDateTime: any;
  startDateTime: any;
  originalDateTimeShift: any = {};

  validStartDate: any;
  hasJobStarted: boolean = false;

  assigneeList: any = [];

  jobStatusTimeChange: any = {};

  selectedAssignee: any = {};
  selectedSiteExtraDetails: any = {};

  etaValue: any;
  etaMinuteTimerInterval: any;
  etaTimeinMinutes: number = 0;
  etaChangeReason: any;
  minEta = getFormattedDateTime();
  etaValueList = [
    { key: '0 min (N/A)', value: 0 },
    { key: '10 mins', value: 10 },
    { key: '15 mins', value: 15 },
    { key: '20 mins', value: 20 },
    { key: '30 mins', value: 30 },
    // { key: '45 minutes', value: 45 },
    // { key: '60 minutes', value: 60 },
  ];
  updateBtnPressed: boolean = false;
  statusUpdateBtnPressed: boolean = false;

  geoAlertDistance: number = 500;

  webSocketSubscription: any;
  deviceInfoSubscription: any;
  nativeUploadSubscription: any;

  loggedInDeviceID: string = this.deviceInfoService.getUniqueDeviceID();

  jobCompleteInvoiceRelatedStatus: any = {};

  previousResponseTypeValue: any;
  responseTypeList: any = [];
  initalResponseTypeList: any = [];
  serviceTypeListData: any = [];
  initalServiceTypeListData: any = [];
  previousServiceTypeValue: any;

  canDeclineJob: boolean = false;
  requiresAcceptance: boolean = false;

  //shift clock in out params

  shiftClockInOutParms = {
    requiresClockInOut: false,
    hasUserClockedIn: false,
    hasUserClockedOut: false,
    jobId: '',
    shiftStartTime: new Date(),
    shiftEndTime: new Date(),
  };

  declineReason: string = '';
  isJobStale: boolean = false;
  // https://app.shortcut.com/sendem/story/10584/early-late-clock-in-out-reason
  jobStartDateTime: any;
  jobEndDateTime: any;

  itemsNotInServer: any = [];
  errorItemsIdsInQueue = new Set();
  syncInProgress: boolean = false;
  askToRefreshPageToPullLatestData: boolean = false;

  sealInfo: any = {};

  jobReceivedAtDateTime = getFormattedDateTime();
  jobReceivedTimerFunction: any;
  jobReceivedDuration: string = '';

  userDetailPopoverTemplate = ViewUserDetailComponent;
  validAssigneeCheckDict: any = {};
  //https://app.shortcut.com/sendem/story/11014/clock-in-clock-out-events-must-take-place-within-100m-of-site
  // https://app.shortcut.com/sendem/story/12509/refactor-gps-lookup-logic
  currentUserLocation: any;
  siteUpdateWarningDistance: number = 100; // metres

  completedTaskCount: number = 0;

  onSiteOffSiteDict: any = {};
  changeStatusTriggered: boolean = false;

  filterPatrolData: any = { checkpoint: [], company: [], site: [] };
  hasQRCheckpoints: boolean = false;
  hasNFCheckpoints: boolean = false;

  updateTask: any;
  nfcReaderAvailable: boolean = false;

  isNativeApp = Capacitor.isNativePlatform();

  constructor(
    private viewContainerRef: ViewContainerRef,
    private spinnerService: LoadingSpinnerService,
    private appService: AppService,
    private jobService: JobsService,
    private clientService: ClientsService,
    private dialogService: ModalDialogueService,
    private router: Router,
    private _location: Location,
    private pageService: PagesService,
    private cdr: ChangeDetectorRef,
    private dataCheckService: DataCheckService,
    private ngZone: NgZone,
    private sanitizer: DomSanitizer,
    private rsService: RosterShiftsService,
    private toasterService: ToasterService,
    private deviceInfoService: DeviceInfoService,
    private route: ActivatedRoute,
    private webSocketService: WebSocketService,
    private userService: UsersService,
    private sqliteDb: SqliteDbService,
    private nativeUploadService: NativeBgUploadService,
  ) {
    const jobId: any = this.route.snapshot.queryParamMap.get('jId');

    if (jobId) {
      localStorage.setItem('urlId', jobId);
    }

    const userData = this.appService.getUserData();

    this.isAdmin = this.dataCheckService.isUserAdmin();

    this.subscriberUserId = userData?.subscriber?.subscriber_user_id;
  }

  ngOnInit(): void {
    // remove cache because if this user makes some changes the cache wont be cleared as websockets will not be triggered
    sessionStorage.removeItem(btoa('jobData'));

    this.deviceInfoService.isDeviceChrome().then((value: any) => {
      this.nfcReaderAvailable = 'NDEFReader' in window && value;
    });

    this.etaValue = getFormattedDateTime();

    this.deviceInfoSubscription =
      this.deviceInfoService.deviceInfoSubject.subscribe((value: any) => {
        if ('appStatus' in value) {
          if (this.offlineMode && value?.appStatus) {
            this.askToRefreshPageToPullLatestData = true;
          }
          this.offlineMode = !value?.appStatus;
        }
        if ('syncComplete' in value) {
          this.syncInProgress = false;
        }
      });
    this.nativeUploadSubscription =
      this.nativeUploadService.apiResponseSubject.subscribe((value: any) => {
        if (
          this.jobDetailData?.id &&
          value?.data?.id == this.jobDetailData?.id
        ) {
          setTimeout(() => {
            this.jobDetailData = value?.data;
            this.formatData(true);
          }, 500);
        }
      });
    this.webSocketSubscription =
      this.webSocketService.webSocketSubject.subscribe((event: any) => {
        const isSameUserOnAnotherDevice =
          this.subscriberUserId === event?.request_user?.subs_id &&
          this.loggedInDeviceID &&
          this.loggedInDeviceID !== event?.request_user?.logged_in_device_id;
        const isAnotherUser =
          this.subscriberUserId !== event?.request_user?.subs_id;

        const allowUser = isSameUserOnAnotherDevice || isAnotherUser;
        if (
          event?.event === 'wsn_individual_runsheet_update' &&
          event?.data?.id === this.jobDetailData?.run_sheet?.id &&
          allowUser
        ) {
          this.fetchJobHistory(false);
        }

        if (
          event?.event === 'individual_job_update' &&
          this.jobDetailData?.id &&
          event?.data?.id === this.jobDetailData?.id &&
          allowUser
        ) {
          // update the changes that come via websocket. This will be helpful for photo uploads

          setTimeout(() => {
            this.jobDetailData = event?.data;
            this.formatData(true);
          }, 100);
        }
        if (
          ['user_job_update', 'wsn_response_job_update'].includes(
            event?.event,
          ) &&
          event?.data?.delete &&
          event?.data?.id === this.jobDetailData?.id &&
          allowUser
        ) {
          // one of the user has deleted the job
          // route to home page.
          this.toasterService.setMessage({
            successMessage: `This job was just deleted by ${event?.request_user?.user_name}`,
            errorMessage: '',
          });
          this.router.navigate(['/']);
        }
        if (event?.event === 'user_job_absolved') {
          this.getJobDetails();
        }
      });

    navigator?.serviceWorker?.controller?.postMessage(
      {
        type: 'INIT_JOB_DETAIL_PORT',
      },
      [this.messageChannel.port2],
    );

    // Listen to the response
    this.messageChannel.port1.onmessage = (event) => {
      if (event?.data?.history == this.jobDetailData?.id) {
        this.getCheckPointScans();
      }
      if (
        this.jobDetailData?.id &&
        event?.data?.data?.id == this.jobDetailData?.id
      ) {
        this.ngZone.run(() => {
          setTimeout(() => {
            this.getCheckPointScans();

            this.jobDetailData = event?.data?.data;
            this.formatData(true);
          }, 100);
        });
      } else if (event?.data?.status === 'failure') {
        this.formatCachedList();
      }
    };

    this.cdr.detectChanges();
    this.getJobDetails();

    this.onsiteVisibilityChangeHandler = () => {
      if (document.visibilityState === 'visible') {
        this.getOnsiteTimerValue();
      }
    };
    this.alarmResposneReceivedVisibilityChangeHandler = () => {
      if (document.visibilityState === 'visible') {
        this.startAlarmReceivedTimerFunction();
      }
    };
    this.getDeviceID();
  }
  ngOnDestroy() {
    this.clearAlarmReceivedInterval();

    if (this.webSocketSubscription) this.webSocketSubscription?.unsubscribe();
    if (this.deviceInfoSubscription) this.deviceInfoSubscription?.unsubscribe();
    if (this.nativeUploadSubscription)
      this.nativeUploadSubscription?.unsubscribe();
    this.clearIntervalTimeoutFunction();
    if (this.etaMinuteTimerInterval) {
      clearInterval(this.etaMinuteTimerInterval);
    }
    document.removeEventListener(
      'visibilitychange',
      this.onsiteVisibilityChangeHandler,
    );
    document.removeEventListener(
      'visibilitychange',
      this.alarmResposneReceivedVisibilityChangeHandler,
    );
    this.messageChannel.port1.onmessage = null;
  }

  getJobReceivedDuration() {
    this.jobReceivedDuration = '';
    if (!this.jobDetailData?.job_received_at) return;
    const diffInTime =
      new Date().getTime() -
      new Date(this.jobDetailData?.job_received_at).getTime();

    let totalMinutes = Math.floor(diffInTime / 1000 / 60);

    this.jobReceivedDuration = `${totalMinutes} mins`;
  }
  clearAlarmReceivedInterval() {
    if (this.jobReceivedTimerFunction) {
      clearInterval(this.jobReceivedTimerFunction);
    }
  }
  startAlarmReceivedTimerFunction() {
    this.clearAlarmReceivedInterval();
    this.getJobReceivedDuration();
    this.ngZone.run(() => {
      this.jobReceivedTimerFunction = setInterval(() => {
        this.getJobReceivedDuration();
      }, 10000);
    });
  }
  async getJobDetailsFromClient(id: string) {
    let result: any;
    // if (this.isNativeApp) {
    //   try {
    //     result = await this.sqliteDb.getCachedItemRow('job', id);
    //   } catch (error) {
    //     throw error;
    //   }
    // } else {
    result = await gTDB.cachedData
      .where('shortPath')
      .equals(`job_${id}`)
      .first();

    this.jobDetailData = result?.jobDetailData;
    this.formatData();
    if (result?.checkPointListInfo) {
      this.formatCheckPointScanData(result?.checkPointListInfo);
    }
    this.fetchingDataFromServer = true;
  }

  async updateJobDetailsToClient(checkPointListInfo?: any) {
    if (!this.jobDetailData?.id) return;
    const shortPath = `job_${this.jobDetailData?.id}`;
    const jobData = {
      jobDetailData: this.jobDetailData,
      shortPath: shortPath,
      updatedAt: new Date().getTime(),
      checkPointListInfo: checkPointListInfo || null,
    };
    await gTDB.cachedData.put(jobData, shortPath);
  }

  getJobDetails() {
    let id = window.localStorage.getItem('urlId');

    if (!id) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'JOB ID NOT FOUND',
      });
      this.router.navigate(['/']);
      return;
    }

    setTimeout(() => {
      this.pageService.miscSubjectParam.next({
        isOnEvent: true,
      });
    }, 100);

    this.spinnerService.show('Fetching Data');
    this.getJobDetailsFromClient(id);

    this.jobService.getJobById(id).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.jobDetailData = response['data'];

        this.formatData();
        this.findSelectedSiteAddInfo();
        this.getCheckPointScans();
      } else {
        this.spinnerService.hide();
        this.toasterService.setMessage({
          errorMessage: response['message'],
          successMessage: '',
        });
      }
      this.spinnerService.hide();
    });

    //check whether offline and localhost
  }

  findSelectedSiteAddInfo() {
    if (!(this.isAdmin || this.isDispatchUser)) {
      return;
    }
    const jobActive = ![1, 2, 3, 9, 10, 11, 12, 13].includes(
      this.jobDetailData?.status?.status_identity?.value,
    );
    this.jobService
      .fetchJobDetails(
        {
          site_id: this.jobDetailData?.sites?.[0]?.id,
          job_type_id: this.jobDetailData?.service_type?.id,
        },
        { get_last_assignees: jobActive ? 1 : 0, additional_site_info: 1 },
      )
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.selectedSiteExtraDetails = {
            ...this.selectedSiteExtraDetails,
            ...response?.data,
          };
          if (jobActive) this.getAssignees();
        } else {
          if (jobActive) this.getAssignees();
        }
      });
  }

  getCancelledReason() {
    this.cancelReasonData = {};
    if (![2, 3].includes(this.jobDetailData?.status?.status_identity?.value))
      return;

    if (this.jobDetailData?.history?.length < 3) return;

    let jobHistory = JSON.parse(
      JSON.stringify(this.jobDetailData?.history?.reverse()),
    );
    jobHistory = jobHistory?.sort(
      (a: any, b: any) =>
        new Date(a?.updated_at).getTime() - new Date(b?.updated_at).getTime(),
    );
    let cancelEvent = jobHistory[jobHistory?.length - 1];
    if (
      cancelEvent &&
      [2, 3].includes(this.jobDetailData?.status?.status_identity?.value)
    ) {
      let cancelReason = jobHistory[jobHistory?.length - 2];

      this.cancelReasonData = {
        reason: cancelReason?.detail,
        time: cancelEvent?.updated_at,
        by: cancelReason?.user_name,
      };
    }
  }
  changeShiftDateTime(dateTimeType: number, event: any) {
    let startDateTimeValid = true;
    if (dateTimeType === 0) {
      this.schedulerForm.controls['start_day'].setValue(
        getFormattedDate(event.target.value),
      );
      const selectedDate = new Date(event.target.value);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (selectedDate < today) {
        this.schedulerForm.controls['start_day'].setErrors({
          invalidStartDate: true,
        });
        startDateTimeValid = false;
      } else {
        this.schedulerForm.controls['start_day'].setErrors(null);
      }
      this.schedulerForm.controls['start_time'].setValue(
        getFormattedTime(event.target.value),
      );
      const scheduleEndDateTime = new Date(
        this.schedulerForm.value.end_day +
          ' ' +
          this.schedulerForm.value.end_time,
      );

      if (
        scheduleEndDateTime.getTime() < new Date(event.target.value).getTime()
      ) {
        const newEndDate = new Date(event.target.value);
        newEndDate.setHours(newEndDate.getHours() + 8);

        this.schedulerForm.controls['end_day'].setValue(
          getFormattedDate(newEndDate),
        );
        this.schedulerForm.controls['end_time'].setValue(
          getFormattedTime(newEndDate),
        );
        this.endDateTime = getFormattedDateTime(newEndDate);
      }
    } else {
      this.schedulerForm.controls['end_day'].setValue(
        getFormattedDate(event.target.value),
      );

      if (
        new Date(getFormattedDate(event.target.value)) <
        new Date(this.schedulerForm.value.start_day)
      ) {
        this.schedulerForm.controls['end_day'].setErrors({
          invalidStartDate: true,
        });
        startDateTimeValid = false;
      } else {
        this.schedulerForm.controls['end_day'].setErrors(null);
      }
      this.schedulerForm.controls['end_time'].setValue(
        getFormattedTime(event.target.value),
      );
    }
  }

  formatSchedule() {
    this.schedulerForm.patchValue(this.jobDetailData?.roster_scheduler);

    let startDay = this.jobDetailData?.schedule_event_date
      ? new Date(this.jobDetailData?.schedule_event_date)
      : this.jobDetailData?.roster_scheduler?.start_day
        ? new Date(this.jobDetailData?.roster_scheduler?.start_day)
        : new Date();
    startDay.setDate(startDay.getDate() - 1);

    const scheduleEndDateTime = new Date(
      (this.jobDetailData?.schedule_event_date
        ? this.jobDetailData?.schedule_event_date
        : this.jobDetailData?.roster_scheduler?.end_day) +
        ' ' +
        this.jobDetailData.roster_scheduler.end_time,
    );
    const staleDate = Math.max(
      new Date(this.jobDetailData?.modified_date).getTime(),
      new Date(scheduleEndDateTime).getTime(),
    );
    this.isJobStale = staleDate + 3600000 * 24 < new Date().getTime();

    this.sheduleIfChecks();
  }
  async formatHistory() {
    // deep copy since sw adds item in the jobHistory list

    this.jobHistoryData = JSON.parse(
      JSON.stringify(this.jobDetailData?.history?.reverse()),
    );
    this.loggedInUpdatesSet.clear();

    if (this.selectedEventId) {
      // in case of delete/restore/edit comments reopen the selected event after the update has been made.
      const updatedEvent = this.jobHistoryData?.find(
        (update: any) => update?.id === this.selectedEventId,
      );
      if (updatedEvent?.id) this.onTableRowClick(updatedEvent);
    }

    await this.formatCachedList();
  }
  formatCachedData(item: any) {
    let eventDict: any = {};

    if (item?.image_source === 'live') {
      eventDict = { event_action: 8, action: 'Uploaded Image' };
    } else if (item?.image_source === 'device') {
      eventDict = { event_action: 19, action: 'File Uploaded' };
    } else {
      eventDict = { event_action: 7, action: 'Added Comment' };
    }

    return {
      cachedData: true,
      isInNativeDb: item?.isInNativeDb || false,
      file_extension: item?.file_extension,
      detail: item?.comment || null,
      gps: item?.device_info?.gps,
      updated_at: item?.updated_at * 1000,
      recorded_at: item?.updated_at * 1000,
      index_db_id: item?.indexDBId,
      file: item?.file || null,
      subs_user_id: this.subscriberUserId,
      ...eventDict,
      device_details: {
        Ip: item?.device_info?.gps?.ip,
        Browser: `${item?.device_info?.browser} - ${item?.device_info?.browser_version}`,
        Device: `${item?.device_info?.device} - ${item?.device_info?.deviceType} `,
      },
    };
  }
  async deleteItemFromNativeDb(update: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Are you sure?',
        message: 'THIS ACTION CANNOT BE UNDONE!',
        btn2Detail: { text: 'Delete', class: 'btn-danger' },
      },
    });
    const dRes = await firstValueFrom(dialogRef.afterClosed());
    if (dRes === true) {
      const pkId = update?.index_db_id;

      if (update?.isInNativeDb) {
        try {
          await this.sqliteDb.deleteSavedUpdateRow('job', pkId);
        } catch (error) {
          throw error;
        }
      } else {
        gTDB.gtSavedData
          .where({
            indexDBId: pkId,
          })
          .delete();
      }

      setTimeout(() => {
        this.fetchJobHistory();
      }, 50);
    }
  }
  formatClientSideCachedItem(cachedItem: any, taskMap: any, historyMap: any) {
    if (!cachedItem || cachedItem?.job_id !== this.jobDetailData?.id) return;

    const cachedItemTimestamp = (cachedItem?.updated_at || 0) * 1000;

    if (cachedItem?.run_sheet_id && cachedItem?.check_list_id) {
      const task = taskMap.get(Number(cachedItem?.check_list_id));

      if (task) {
        task.task_completed_info = {
          id: cachedItem?.indexDBId,
          cachedData: true,
          detail: cachedItem?.comment || null,
          updated_at: cachedItemTimestamp,
          recorded_at: cachedItemTimestamp,
          updated_datetime: cachedItemTimestamp,
          index_db_id: cachedItem?.indexDBId,
          user_name: 'You',
        };
      }
      return;
    }

    //  Existing History Item Updates
    if (cachedItem?.id) {
      if (
        cachedItem?.edit_comment ||
        cachedItem?.delete_update ||
        cachedItem?.restore_update
      ) {
        const update = historyMap.get(Number(cachedItem?.id));

        if (update) {
          update.cachedData = true;
        }
      }
      return;
    }

    // Remaining Data List Additions
    const lookupKey = `${cachedItem?.indexDBId}|${cachedItemTimestamp}`;

    if (!this.loggedInUpdatesSet.has(lookupKey)) {
      this.loggedInUpdatesSet.add(lookupKey);
      const data = this.formatCachedData(cachedItem);

      this.jobHistoryData.push(data);
    }
  }
  async formatCachedList() {
    const apiResponseDict: any =
      (await gTDB.userData.get('apiResponseDict')) || {};

    this.itemsNotInServer = [];
    this.errorItemsIdsInQueue.clear();

    const itemsNotInServerIds = new Set();

    const loggedInUsersUpdates = this.jobHistoryData?.filter(
      (item: any) =>
        item?.subs_user_id == this.subscriberUserId &&
        [7, 8, 19].includes(item?.event_action),
    );

    let nativeDbDataList: any = [];
    if (this.isNativeApp) {
      try {
        nativeDbDataList = await this.sqliteDb.getSavedUpdateRow(
          'job',
          this.jobDetailData?.id,
        );
      } catch (error) {
        throw error;
      }
    }

    const indexedDbListData: any = await this.getAllIndexedDbItems();

    const taskMap = new Map<any, any>();
    this.jobDetailData?.check_list_tasks?.forEach((task: any) => {
      if (task?.id) taskMap.set(task.id, task);
    });

    const historyMap = new Map<any, any>();
    this.jobHistoryData?.forEach((update: any) => {
      if (update?.id) historyMap.set(update.id, update);
    });

    loggedInUsersUpdates?.forEach((item: any) => {
      if (item?.index_db_id && item?.recorded_at) {
        const timestamp = new Date(item.recorded_at).getTime();

        this.loggedInUpdatesSet.add(`${item.index_db_id}|${timestamp}`);
      }
    });

    indexedDbListData.forEach((cachedItem: any) => {
      this.formatClientSideCachedItem(cachedItem, taskMap, historyMap);

      const failedItem =
        apiResponseDict?.[cachedItem?.indexDBId]?.errorMessages?.length;
      if (failedItem) {
        // had an error

        cachedItem.errorMessages =
          apiResponseDict?.[cachedItem?.indexDBId]?.errorMessages;
        if (!itemsNotInServerIds.has(cachedItem?.indexDBId)) {
          itemsNotInServerIds.add(cachedItem?.indexDBId);
          this.itemsNotInServer.push(cachedItem);
        }
        this.errorItemsIdsInQueue.add(cachedItem?.indexDBId);
      }
      const notInServerYet = cachedItem?.cachedData || !cachedItem?.id;
      if (notInServerYet && !itemsNotInServerIds.has(cachedItem?.indexDBId)) {
        itemsNotInServerIds.add(cachedItem?.indexDBId);
        this.itemsNotInServer.push(cachedItem);
      }
    });

    for (const data of nativeDbDataList) {
      const requestData = JSON.parse(data?.data) || {};
      const cachedItem = requestData?.body || {};
      cachedItem.indexDBId = data?.id;
      cachedItem.updated_at = new Date(data?.updatedAt).getTime() / 1000;
      cachedItem.job_id = data?.eventId;

      cachedItem.isInNativeDb = true;
      cachedItem.pathName =
        this.pageService.getPathNameForSavedUpdatesInNativeDb(data?.type);
      if (requestData?.uploadedFilePath) {
        cachedItem.file = await this.appService.getDisplayUrlForFileInDevice(
          requestData.uploadedFilePath,
        );
      }
      this.formatClientSideCachedItem(cachedItem, taskMap, historyMap);
      if (data?.status == 4 && data?.retryResponse) {
        // had an error
        const errorMessages = JSON.parse(data?.retryResponse);
        const lastError = errorMessages[errorMessages?.length - 1].split(':');
        if (lastError?.[1]) {
          cachedItem.errorMessages = [lastError?.[1]];
          if (!itemsNotInServerIds.has(cachedItem?.indexDBId)) {
            itemsNotInServerIds.add(cachedItem?.indexDBId);
            this.itemsNotInServer.push(cachedItem);
          }
          this.errorItemsIdsInQueue.add(cachedItem?.indexDBId);
        }
      }
      const notInServerYet = cachedItem?.cachedData || !cachedItem?.id;
      if (notInServerYet && !itemsNotInServerIds.has(cachedItem?.indexDBId)) {
        itemsNotInServerIds.add(cachedItem?.indexDBId);
        this.itemsNotInServer.push(cachedItem);
      }
    }
    if (this.jobCheckpointListData?.length) {
      const scan_updates = await this.sqliteDb.getSavedUpdateRow(
        'scan_checkpoint',
        this.jobDetailData?.id,
      );
      for (const scan of scan_updates) {
        const scanData = JSON.parse(scan?.data);
        const checkpointIndex = this.jobCheckpointListData?.findIndex(
          (cp: any) =>
            cp?.id == scanData?.body?.check_point_id &&
            !cp?.updated_datetime &&
            !cp?.is_deleted,
        );
        if (checkpointIndex > -1) {
          this.jobCheckpointListData[checkpointIndex] = {
            ...this.jobCheckpointListData[checkpointIndex],
            updated_datetime: scan?.updatedAt,
            user_name: 'You',
          };
        }
      }
    }

    this.jobHistoryData = this.jobHistoryData?.sort(
      (a: any, b: any) =>
        new Date(b?.updated_at).getTime() - new Date(a?.updated_at).getTime(),
    );
    const completedTasks = this.jobDetailData?.check_list_tasks?.filter(
      (task: any) => task?.task_completed_info?.updated_datetime,
    );

    this.completedTaskCount = completedTasks?.length;

    this.jobCommentsFilesStatusData = [
      ...this.jobHistoryData?.filter((item: any) =>
        // 8, _("uploaded image")
        // 19, ("file uploaded")
        // 1, _("changed status")
        // 7, _("added comment")
        [8, 19, 7, 1].includes(item?.event_action),
      ),
    ];

    if (
      this.jobDetailData?.status?.status_identity?.value === 1 &&
      this.jobDetailData?.can_reopen
    ) {
      // if completd job find the last status to reopen
      const statusChangeList = this.jobHistoryData?.filter(
        (item: any) => item?.event_action === 1,
      );
      if (statusChangeList?.length) {
        // second last from the list as the list has been sorted
        const prevStatus = statusChangeList[statusChangeList?.length - 2];
        this.lastStatus = this.jobStatusesListData.find(
          (s: any) => s?.status?.id === prevStatus?.changed_status_id,
        );
      }

      if (!this.lastStatus) {
        this.lastStatus = this.backupLastStatus();
      }
    }
    this.appService.removeToolTips();

    this.appService.initializeBootstrapTooltips();
  }
  areSameDay(date1: Date, date2: Date): boolean {
    const year1 = date1.getFullYear();
    const month1 = date1.getMonth();
    const day1 = date1.getDate();

    const year2 = date2.getFullYear();
    const month2 = date2.getMonth();
    const day2 = date2.getDate();

    return year1 === year2 && month1 === month2 && day1 === day2;
  }
  routeToReviewPage(autoRoute: boolean = false) {
    this.router.navigate([`/job-review/${this.jobDetailData?.job_key}`], {
      queryParams: { jId: this.jobDetailData?.id },
      replaceUrl: autoRoute,
    });
  }
  reloadPage() {
    window.location.reload();
  }

  formatData(bgUpdate = false) {
    this.askToRefreshPageToPullLatestData = false;
    if (!bgUpdate) {
      this.dialogRef?.close();
    }

    this.getStatusTextandColor();
    const targetUrl = `/job-detail/${this.jobDetailData?.job_key}`;

    if (this.router.url !== targetUrl) {
      this.router.navigate([targetUrl], { replaceUrl: true });
    }
    this.isDispatchUser = this.dataCheckService.isDispatchUser({
      permission: 'job_type',
      action: 'edit',
      id: this.jobDetailData?.service_type?.id,
    });

    if (
      [0].includes(this.jobDetailData?.service_type?.type_identity) &&
      [0, 4, 5, 8].includes(this.jobDetailData?.status?.status_identity?.value)
    ) {
      document.addEventListener(
        'visibilitychange',
        this.alarmResposneReceivedVisibilityChangeHandler,
      );
      this.startAlarmReceivedTimerFunction();
    }
    this.clearIntervalTimeoutFunction();

    if (this.jobDetailData?.status?.status_identity?.value === 4) {
      this.startOnsiteCountUp();
      document.addEventListener(
        'visibilitychange',
        this.onsiteVisibilityChangeHandler,
      );
    }

    if (this.jobDetailData?.roster_scheduler?.repeat_type) {
      this.formatSchedule();
      this.getTimeDifference();
    }
    this.jobStatusTimeChange.created_at = getFormattedDateTime(
      this.jobDetailData?.created_date,
    );

    this.formatHistory();

    if (this.jobDetailData?.status?.status_identity?.value === 8) {
      // if the status is `In Transit` show eta
      this.jobDetailData.showEta = true;

      const eta = this.jobDetailData?.additional_info?.eta;

      if (eta > 100000000) {
        this.jobDetailData.eta = new Date(eta);
        this.jobDetailData.sameDay = this.areSameDay(new Date(eta), new Date());

        this.updateEtaMinutes(this.jobDetailData?.eta);

        this.etaValue = getFormattedDateTime(this.jobDetailData.eta);
      }
    }

    this.getCancelledReason();
    this.selectedInterval = this.jobDetailData?.interval_check
      ? this.jobDetailData?.interval_check
      : this.intervalData[0]?.value;
    this.ngZone.run(() => {
      setTimeout(() => {
        this.calculateFixedBottomHeight();
        this.spinnerService.hide();
        this.updateBtnPressed = false;
        this.statusUpdateBtnPressed = false;
      }, 100);
    });

    if (this.jobDetailData?.eta) {
      this.etaMinuteTimerInterval = setInterval(() => {
        this.updateEtaMinutes(this.jobDetailData?.eta);
      }, 5000);
    } else if (this.etaMinuteTimerInterval) {
      clearInterval(this.etaMinuteTimerInterval);
    }
    this.fetchingDataFromServer = false;

    if (
      this.jobDetailData?.run_sheet?.id &&
      this.jobDetailData?.check_list_tasks?.length
    ) {
      this.jobDetailData?.history?.forEach((log: any) => {
        if (log?.event_action === 1) {
          if (log?.status_identity == 4) {
            this.onSiteOffSiteDict['onsite'] = log?.updated_datetime;
          }
          if (log?.status_identity == 5) {
            this.onSiteOffSiteDict['offsite'] = log?.updated_datetime;
          }
        }
      });
    }
    this.updateJobDetailsToClient();
  }
  updateEtaMinutes(eta: any) {
    // added an interval to update the eta remaining minutes
    const diffInTime = new Date(eta)?.getTime() - new Date().getTime();
    const diffInMinutes = Math.floor(diffInTime / (1000 * 60)) + 1;

    this.jobDetailData.etaDiff = {
      minutes: diffInMinutes,
    };
  }

  updateJobStatus(value: any) {
    if (value) {
      this.updateJobDetail({ job_status_id: value.id });
    }
  }

  getRequestDetails() {
    let requestData: any = {};
    requestData['method'] = 'put';
    requestData['url'] = 'api/job/' + this.jobDetailData.id + '/';
    requestData['id'] = this.jobDetailData.id;
    return requestData;
  }

  async updateJobDetail(body: any, showToaster: boolean = true) {
    if (!body) return false;
    if (this.jobDetailData?.has_been_24hrs) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage:
          'You cannot make changes to a completed job after 24 hours',
      });
      return false;
    }

    let requestData = this.getRequestDetails();

    this.updateBtnPressed = true;
    this.spinnerService.show('Updating Job detail');
    requestData['data'] = body;
    const prevStatusId = this.jobDetailData?.status?.status_identity?.value;
    const response: any = await this.jobService.updateJob(requestData);
    if (response?.status !== 'success') {
      this.spinnerService.show('Fetching latest data from server');
      this.getJobDetails();

      this.updateBtnPressed = false;
      this.statusUpdateBtnPressed = false;

      this.toasterService.setMessage({
        errorMessage: response['message'],
      });
      return true;
    }

    this.jobDetailData = response?.data;
    if (prevStatusId !== this.jobDetailData?.status?.status_identity?.value) {
      // https://app.shortcut.com/sendem/story/10819/add-vibration-to-certain-actions-to-improve-ux

      this.deviceInfoService.triggerCustomPulsePattern([
        80, 30, 80, 30, 80, 60, 300,
      ]);
    }

    const isDispatcherAdmin = this.isAdmin || this.isDispatchUser;
    const isJobDeclined =
      !isDispatcherAdmin &&
      body?.decline_job &&
      body?.decline_reason &&
      !this.jobDetailData?.assignee?.some(
        (user: any) => user?.id == this.subscriberUserId,
      );
    if (
      !response?.data?.id ||
      this.jobDetailData?.status?.status_identity?.value === 2 ||
      isJobDeclined ||
      this.jobDetailData?.status?.status_identity?.value === 1 ||
      this.jobDetailData?.status?.status_identity?.value === 7 ||
      (this.jobDetailData?.status?.status_identity?.value === 9 &&
        !isDispatcherAdmin)
    ) {
      this._location.back();
      return true;
    }

    if (showToaster === true) {
      this.dialogRef?.close();
      this.toasterService.setMessage({
        successMessage: response['message'],
        errorMessage: '',
      });
    }

    // 9 = job completed, auto route to review page upon completion
    if (
      this.jobDetailData?.status?.status_identity?.value === 9 &&
      prevStatusId != 9 &&
      isDispatcherAdmin
    ) {
      // review job
      setTimeout(() => {
        this.routeToReviewPage(true);
      }, 100);

      return true;
    }

    this.etaChangeReason = '';
    this.cancelReason = '';

    this.formatData();
    if (body?.update_checkpoints) {
      this.getCheckPointScans();
    }

    this.spinnerService.hide();
    return true;
  }
  async openUploadPhotoComponent() {
    this.deviceInfoService
      .getGpsCoordinates()
      .then((gps: any) => (this.currentUserLocation = gps));

    const dialogRf = this.dialogService.open(FileUploadComponent, {
      data: { showFrom: 'updateJob' },
    });
    const dResp = await firstValueFrom(dialogRf.afterClosed());
    if (dResp && dResp !== 'error') {
      this.onFileSubmit(dResp);
    } else if (dResp == 'error') {
      this.toasterService.setMessage({
        errorMessage: 'Unable to access your camera',
      });
    }
  }

  //Method to upload the photo for selected site or job
  async onFileSubmit(value: any) {
    if (!value?.actualFileUpload) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'Please add a photo',
      });
      return;
    }

    let fileData: FormData = new FormData();
    let params: any = {};

    if (value?.newComment) {
      fileData.append('comment', value?.newComment);
    }

    if (value?.uploadedAt) {
      fileData.append('updated_at', value?.uploadedAt);
    }

    if (value?.actualFileUpload) {
      fileData.append('file', value?.actualFileUpload);
      fileData.append('image_source', value?.uploadType);
      fileData.append('file_extension', `.${value?.fileExtension}`);
      if (value?.actualFileUpload?.type?.startsWith('video/')) {
        params['video_upload'] = 1;
      }
    }
    if (value?.fileUrl) {
      fileData.append('uploadedFileBase64', value?.fileUrl);
    }

    if (value?.exifData && Object.values(value?.exifData)?.length) {
      fileData.append('exif_data', JSON.stringify(value?.exifData));
    }
    this.callUploadApi(fileData, params);
  }
  async callUploadApi(
    fileData: any,
    params: any,
    spinnerMessage: string = 'Uploading - Please Wait',
  ) {
    this.spinnerService.show(spinnerMessage);

    fileData.append(
      // to see the data in queued update log
      'jobDetails',
      JSON.stringify({
        job_key: this.jobDetailData?.job_key,
        company: this.jobDetailData?.company?.company_name,
      }),
    );
    fileData.append('job_id', this.jobDetailData?.id);

    const response: any = await this.appService.backUpAndUploadUpdate(
      `job/update_job`,
      fileData,
      params,
      'POST',
      this.currentUserLocation,
    );

    this.clearInfo();
    this.formatHistory();
    if (this.offlineMode && response?.status == 'success') {
      this.toasterService.setMessage({
        successMessage: 'Action Queued',
        errorMessage: '',
      });
    }

    if (response?.data) {
      this.jobDetailData = response['data'];
      this.formatData();
    }

    this.spinnerService.hide();
  }

  updateRequestDetails(_type: string) {
    let body: any = {};
    body[_type === 'in' ? 'internal_notes' : 'request'] =
      this.updatedJobExtraInfo;
    this.updateJobDetail(body);
  }

  onAssigneeSearch(event: any) {
    if (event.target.value?.length > 0) {
      this.getAssignees({ search_str: event?.target?.value });
    } else {
      this.getAssignees();
    }
  }

  getAssignees(params?: any) {
    const reqParams = params || {};

    let reqBody: any = {};

    if (this.selectedSiteExtraDetails?.last_assignees) {
      const assigneeIds = Object.keys(
        this.selectedSiteExtraDetails?.last_assignees || {},
      );

      if (assigneeIds?.length)
        reqBody.sort_assignee_ids = assigneeIds?.slice(0, 5);
    }
    if (this.selectedSiteExtraDetails?.preferred_user_ids) {
      const assigneeIds =
        this.selectedSiteExtraDetails?.preferred_user_ids || [];

      if (assigneeIds?.length) reqBody.preferred_user_ids = assigneeIds;
    }
    this.jobService
      .getUserList(reqParams, reqBody)
      .subscribe(async (response: any) => {
        if (response['status'] == 'success') {
          setTimeout(() => {
            this.assigneeList = JSON.parse(JSON.stringify(response?.data));
            this.cdr.detectChanges();
          }, 50);
        }
      });
  }

  makeSiteContactSelectionChanges() {
    this.siteContactList.forEach((sContact: any) => {
      sContact.selected = this.jobDetailData?.location_contacts?.some(
        (selectedContact: any) => selectedContact?.id === sContact?.id,
      );
    });
    this.siteContactList.sort((a: any, b: any) => {
      if (a?.selected === b?.selected) {
        return 0;
      }
      return a?.selected ? -1 : 1;
    });
  }

  async onAssigneeSelect(assignee: any) {
    if (assignee?.id) {
      let validAssignee: any = false;

      if (assignee?.id in this.validAssigneeCheckDict) {
        validAssignee = this.validAssigneeCheckDict[assignee?.id];
      } else {
        validAssignee = await this.checkValidCredentialsForAssignee(
          assignee?.id,
        );
      }

      this.validAssigneeCheckDict[assignee?.id] = validAssignee;
      if (validAssignee) {
        this.selectedAssignee = assignee;
      } else {
        let dialogMsg;
        if (this.subscriberUserId === assignee?.id) {
          dialogMsg =
            'You may not hold the requried credentials (e.g. Security Licence, Police Checks, etc...) for this job. You can upload your credentials under your profile settings, or ignore this message.';
        } else {
          dialogMsg = `${
            assignee.full_name || assignee.email
          } may not hold the appropriate credentials (e.g. Security Licence) for this job. Ignore?`;
        }
        const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
          data: {
            title: 'Job Assignment',
            message: dialogMsg,
          },
        });

        const dResp = await firstValueFrom(dialogRef.afterClosed());

        if (dResp === true) {
          this.selectedAssignee = assignee;
        } else {
          this.shiftFocus('assigneLookupFieldId');
          this.selectedAssignee = {};
        }
      }
    }
  }
  backupLastStatus() {
    const reopenStatus =
      this.jobStatusesListData.find(
        (s: any) => s?.status.status_identity.value === 6,
      ) ||
      this.jobStatusesListData.find(
        (s: any) => s?.status.status_identity.value === 0,
      );
    return reopenStatus;
  }

  moveJobBack() {
    if (this.jobDetailData?.has_been_24hrs) {
      this.toasterService.setMessage({
        errorMessage:
          'You cannot make changes to a completed job after 24 hours',
        successMessage: '',
      });
    } else {
      if (this.lastStatus?.status?.id) {
        const dialogRef = this.dialogService.open(
          ConfirmDialogComponent,
          {
            data: {
              title: 'Reopen Job',
              message:
                'WARNING: Site contacts will be notified if you reopen this job.',
            },
          },
          this.viewContainerRef,
        );
        dialogRef.afterClosed().subscribe((value: any) => {
          if (value === true) {
            this.updateJobStatus(this.lastStatus?.status);
          }
        });
      }
    }
  }
  reviewJob() {
    this.updateJobDetail(
      {
        job_status_id: this.jobCompleteInvoiceRelatedStatus?.review?.status?.id,
      },
      false,
    );
  }
  approveJob(sendReport = false) {
    const dialogRef = this.dialogService.open(
      ConfirmDialogComponent,
      {
        data: {
          title: 'Approve Job',
          message: `Mark the job as complete. ${
            sendReport ? 'Send reports to client' : ''
          }`,
        },
      },
      this.viewContainerRef,
    );
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        let reqBody: any = {
          job_status_id:
            this.jobCompleteInvoiceRelatedStatus?.approve?.status?.id,
        };
        if (sendReport) {
          reqBody.send_report = true;
        }
        this.updateJobDetail(reqBody);
      }
    });
  }

  onTableRowClick(event: any) {
    this.selectedEvent = event;
    this.selectedEventId = event?.id;
  }

  closeStatusDropDown() {
    setTimeout(() => {
      this.statusDropdownOpen = false;
      this.cdr.detectChanges();
    }, 200);
  }
  checkAndModifyETA(etaValue: any) {
    const selectedETA = new Date(etaValue).getTime();
    return selectedETA > new Date().getTime() + 1000 * 60 ? selectedETA : 0; // implies the user has selected N/A;
  }
  updateJobOnsiteOffsiteStatus(updateStatus: any) {
    const requireClockIn =
      this.shiftClockInOutParms.requiresClockInOut &&
      [2].includes(this.jobDetailData?.service_type?.type_identity) &&
      updateStatus?.status?.status_identity.value === 4 &&
      !this.shiftClockInOutParms.hasUserClockedIn;

    if (requireClockIn) {
      this.onClockInOutUser(updateStatus);
      return;
    }
    const requireClockOut =
      this.shiftClockInOutParms.requiresClockInOut &&
      [2].includes(this.jobDetailData?.service_type?.type_identity) &&
      updateStatus?.status?.status_identity.value === 5 &&
      !this.shiftClockInOutParms.hasUserClockedOut;

    if (requireClockOut) {
      this.onClockInOutUser(updateStatus);
      return;
    }

    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Update Status',
        message: `Update job status to ${updateStatus?.status?.name}`,
        btn2Detail: { text: 'Yes' },
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value) {
        this.updateJobDetail({
          user_provided_timestamp: new Date(),
          job_status_id: updateStatus?.status?.id,
        });
      } else {
        this.selectedStatus = null;
        this.statusDropdownOpen = false;
      }
    });
  }
  async pendingTaskORScansCheck() {
    return new Promise((resolve) => {
      // https://app.shortcut.com/sendem/story/11201/prevent-offsite-status-for-scheduled-patrols
      const isTherePendingTasks = this.jobDetailData?.check_list_tasks?.some(
        (task: any) => !task?.task_completed_info?.updated_datetime,
      );
      const isTherePendingScans = this.jobCheckpointListData?.some(
        (scan: any) => !scan?.updated_datetime,
      );

      if (isTherePendingTasks || isTherePendingScans) {
        const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
          data: {
            title: 'Pending Tasks/Scans',
            message: 'Warning: You have pending tasks/scans',
            btn2Detail: { text: 'Ignore' },
          },
        });
        dialogRef.afterClosed().subscribe((dialogResponse: any) => {
          resolve(dialogResponse);
        });
      } else {
        resolve(true);
      }
    });
  }

  async changeJobStatus(
    changedStatus: any,
    jobCancelDeleteTemplate: any,
    inTransitTemplate: any,
    pendingUpdateTemplate: any,
    siteUpdateRadiusWarningTemplate: any,
  ) {
    try {
      if (this.changeStatusTriggered) return;
      this.changeStatusTriggered = true;
      // sync data on every status change to make sure the app clears everything in the queue
      if (this.itemsNotInServer?.length) this.syncData();
      const updateStatus = this.jobStatusesListData.find(
        (s: any) => s?.status?.id === changedStatus?.status?.id,
      );

      if (!updateStatus?.status?.id) {
        this.selectedStatus = null;
        return;
      }

      // change status to onsite or offsite

      if ([4, 5].includes(updateStatus?.status?.status_identity.value)) {
        if (updateStatus?.status?.status_identity.value === 5) {
          const skipPendingTasks = await this.pendingTaskORScansCheck();
          if (!skipPendingTasks) return;
        }

        const isUserAwayFromSite = await this.isUpdateNearSite();

        if (isUserAwayFromSite) {
          const dialogRef = this.dialogService.open(
            siteUpdateRadiusWarningTemplate,
            {
              data: {
                scan_detail: {
                  lat: this.jobDetailData?.sites?.[0]?.address?.latitude,
                  lon: this.jobDetailData?.sites?.[0]?.address?.longitude,
                },
                min_distance: this.siteUpdateWarningDistance,
                gps: {
                  markerTooltip: 'Your Location',
                  ...this.currentUserLocation,
                },
              },
            },
            this.viewContainerRef,
          );
          const dRes = await firstValueFrom(dialogRef.afterClosed());

          if (dRes) {
            this.updateJobOnsiteOffsiteStatus(updateStatus);
          }

          return;
        }
        this.updateJobOnsiteOffsiteStatus(updateStatus);
      } else if (updateStatus?.status?.status_identity.value === 8) {
        // intranst status
        this.dateTimeValue = getFormattedDateTime();
        this.jobStatusTimeChange.currentTime = getFormattedDateTime();
        this.jobStatusTimeChange.valid = true;

        const dialogRef = this.dialogService.open(
          inTransitTemplate,
          {
            data: { name: updateStatus?.status?.name },
          },
          this.viewContainerRef,
        );
        const dRes = await firstValueFrom(dialogRef.afterClosed());
        if (dRes !== false) {
          this.updateJobDetail({
            job_status_id: updateStatus?.status?.id,
            eta: this.checkAndModifyETA(dRes),
          });
        } else {
          this.selectedStatus = null;
        }
      } else if ([2, 3].includes(updateStatus?.status?.status_identity.value)) {
        // cacncel status
        const dialogRef = this.dialogService.open(
          jobCancelDeleteTemplate,
          {
            data: { delete: false },
          },
          this.viewContainerRef,
        );
        const dRes = await firstValueFrom(dialogRef.afterClosed());
        if (dRes !== false) {
          this.updateJobDetail({
            job_status_id: updateStatus?.status?.id,
            comment: this.cancelReason,
          });
        } else {
          this.cancelReason = '';
          this.selectedStatus = null;
        }
      } else if (updateStatus?.status?.status_identity.value == 7) {
        // delete status
        const dialogRef = this.dialogService.open(
          jobCancelDeleteTemplate,
          {
            data: { delete: true },
          },
          this.viewContainerRef,
        );
        const dRes = await firstValueFrom(dialogRef.afterClosed());
        if (dRes !== false) {
          this.updateJobDetail({
            job_status_id: updateStatus?.status?.id,
            delete_reason: this.cancelReason,
          });
        } else {
          this.cancelReason = '';
          this.selectedStatus = null;
        }
      } else if (updateStatus?.status?.status_identity.value == 1) {
        // complete status
        // fetch latest updates from the server to check if any of the updates are not in server but still in queue
        await this.fetchJobHistory(false);

        if (this.itemsNotInServer?.length) {
          // pending items in queue
          const pendingUpdateDialogBox = this.dialogService.open(
            pendingUpdateTemplate,
            {
              data: { pendingItemsCount: this.itemsNotInServer?.length },
            },
            this.viewContainerRef,
          );

          pendingUpdateDialogBox?.afterClosed().subscribe(() => {
            this.appService.removeToolTips();
            this.selectedStatus = null;
          });
        } else {
          const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
            data: {
              title: 'Confirmation Needed',
              message: 'Mark the job as complete',
            },
          });
          const dRes = await firstValueFrom(dialogRef.afterClosed());
          if (dRes === true) {
            this.updateJobDetail({
              job_status_id: updateStatus?.status?.id,
            });
          } else {
            this.selectedStatus = null;
          }
        }
      } else {
        this.updateJobDetail({
          job_status_id: updateStatus?.status?.id,
        });
      }
    } catch (error) {
    } finally {
      setTimeout(() => {
        this.statusDropdownOpen = false;
        this.changeStatusTriggered = false;
      }, 300);
    }
  }
  addRemoveSiteContact(contactData: any) {
    contactData.selected = !contactData?.selected;
    if (contactData.selected) {
      this.addSiteContact(contactData?.id);
    } else {
      this.onSiteContactDeselect(contactData);
    }
  }
  modifySiteContactTemplate(modifySiteContactRef: any) {
    if (
      !this.offlineMode &&
      ![1, 2, 3, 9, 10, 11, 12, 13].includes(
        this.jobDetailData?.status?.status_identity?.value,
      ) &&
      (this.isAdmin || this.isDispatchUser)
    ) {
      this.siteContactList = [];
      this.getSiteContacts();
      this.dialogRef = this.dialogService.open(
        modifySiteContactRef,
        {},
        this.viewContainerRef,
      );
    }
  }
  getSiteContacts() {
    this.clientService
      .getSiteContacts(this.jobDetailData?.sites?.[0]?.id)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.siteContactList = response['data'];
          this.makeSiteContactSelectionChanges();
        }
      });
  }
  addSiteContact(contactId: any) {
    this.updateJobDetail({ new_site_contact: contactId });
  }
  onSiteContactDeselect(contact: any) {
    this.updateJobDetail({ remove_site_contact: contact.id });
  }
  addLocationContact() {
    let siteData: any = this.jobDetailData?.sites?.[0];
    siteData['contacts'] = this.siteContactList;

    const dialogRef = this.dialogService.open(ContactComponent, {
      data: {
        siteData: siteData,
        addNewSiteContact: true,
        contactType: 'lc',
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value !== 'false') {
        this.siteContactList = value;
        let lastAddedContact =
          this.siteContactList[this.siteContactList.length - 1];
        this.makeSiteContactSelectionChanges();
        this.addSiteContact(lastAddedContact?.id);
      }
    });
  }

  getStatusTextandColor() {
    this.jobStatusesListData = this.jobDetailData?.service_type?.statuses;
    this.selectedJobStatus = this.jobDetailData?.status || {};

    this.availableStatusesListData = this.jobDetailData?.service_type?.statuses
      ?.map((obj: any) => {
        const statusValue = obj?.status?.status_identity?.value;
        if ([9, 10, 11, 12, 13].includes(statusValue)) {
          this.formatAfterCompleteStatus(obj);
        }
        if (
          (statusValue === 2 || statusValue === 3) &&
          (this.isAdmin || this.isDispatchUser)
        ) {
          return {
            ...obj,
            status: {
              ...obj.status,
              name: 'Cancel Job',
              color: 'var(--button--danger-text-color)',
            },
          };
        } else if (
          statusValue !== 6 &&
          this.selectedJobStatus?.id !== obj?.status?.id
        ) {
          return obj;
        }
      })
      ?.filter(Boolean);

    this.availableStatusesListData = this.filterStatuses(
      this.availableStatusesListData,
      [
        this.jobDetailData?.next_status?.forward_status,
        this.jobDetailData?.next_status?.backward_status,
        this.jobDetailData?.next_status?.reverse_status,
      ],
    );
  }

  formatAfterCompleteStatus(statuObj: any) {
    const statusIdentiy = statuObj?.status?.status_identity?.value;
    let statusKey = '';

    switch (statusIdentiy) {
      case 9:
        statusKey = this.jobDetailData?.sites?.[0]?.auto_send_reports
          ? ''
          : 'review';
        if (this.jobDetailData?.status?.status_identity?.value === 10)
          statusKey = 'review';
        break;
      case 10:
        statusKey = 'approve';
        break;
    }
    if (statusKey) {
      this.jobCompleteInvoiceRelatedStatus[statusKey] = statuObj;
    }
  }

  modifyAssignees(modifyAssigneeRef: any) {
    this.getAssignees();
    this.selectedAssignee = this.jobDetailData?.assignee?.[0];

    this.dialogRef = this.dialogService.open(
      modifyAssigneeRef,
      {},
      this.viewContainerRef,
    );
  }
  modifyJobExtraInfo(requestRef: any, _type: string, currentValue: any) {
    if (this.isAdmin === true || this.isDispatchUser === true) {
      this.updatedJobExtraInfo = currentValue;
      this.dialogRef = this.dialogService.open(
        requestRef,
        { data: { _type: _type, currentValue: currentValue } },
        this.viewContainerRef,
      );
    }
  }
  openSiteContactTemplate(data: any) {
    let siteData: any = this.jobDetailData?.sites?.[0];

    this.dialogRef = this.dialogService.open(ContactComponent, {
      data: {
        contactData: data,
        siteData: siteData,
      },
    });
    this.dialogRef.afterClosed().subscribe((dialogResponse: any) => {
      if (dialogResponse !== 'false') {
        this.getJobDetails();
      }
    });
  }

  clearInfo() {
    this.currentUserLocation = null;
    this.dialogRef?.close();
  }

  redirect(location: string) {
    if (location === 'mc') {
      this.router.navigate([
        '/view-company',
        { cKey: String(this.jobDetailData?.monitoring_company?.id) },
      ]);
    } else if (location === 'runsheet') {
      this.router.navigate([
        '/view-runsheet',
        { rKey: String(this.jobDetailData?.run_sheet?.id) },
      ]);
    } else if (location === 'client') {
      this.router.navigate([
        '/view-client',
        { cKey: String(this.jobDetailData?.company_id) },
      ]);
    } else {
      this.router.navigate([
        '/view-site',
        { sKey: String(this.jobDetailData?.sites?.[0]?.id) },
      ]);
    }
  }

  onlineRedirect(location: string) {
    if (!this.offlineMode) {
      if (location === 'mc') {
        this.router.navigate([
          '/view-company',
          { cKey: String(this.jobDetailData?.monitoring_company?.id) },
        ]);
      } else if (location === 'client') {
        this.router.navigate([
          '/view-client',
          { cKey: String(this.jobDetailData?.company_id) },
        ]);
      } else {
        this.router.navigate([
          '/view-site',
          { sKey: String(this.jobDetailData?.sites?.[0]?.id) },
        ]);
      }
    }
  }

  onOpenImage(event: any, data: any) {
    var target = event.target || event.srcElement || event.currentTarget;
    var srcAttr = target.attributes.src;

    this.dialogService.open(MediaPreviewComponent, {
      data: {
        mediaSrc: srcAttr.nodeValue,
        timeStamp: data?.updated_datetime ?? data?.updated_at,
      },
    });
  }

  showOfflineMessage() {
    this.toasterService.setMessage({
      successMessage: '',
      errorMessage: 'Feature not available while offline',
    });
  }

  changeStatusTimeStamp(event: any, eventData: any) {
    const selectedTime = event?.target.value
      ? new Date(event?.target.value).getTime()
      : new Date(eventData?.currentValue).getTime();

    eventData.valid =
      selectedTime >= eventData?.minDateTime?.getTime() &&
      selectedTime <= eventData?.maxDateTime?.getTime();
  }

  onMcSearch(event: any) {
    this.mcInputValue = event?.target?.value;
    if (event?.target?.value.length > 2) {
      this.getMonitoringCompanyList({ search_str: event?.target?.value });
    }
  }

  getMonitoringCompanyList(params?: any) {
    this.clientService
      .fetchMonitoringCompanyList(params)
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          this.monitoringCompanyList = res['data'];
        }
      });
  }
  modifyMonitoringCompany(requestRef: any) {
    this.getMonitoringCompanyList();
    this.mcInputValue = this.jobDetailData?.monitoring_company?.company_name;
    this.dialogRef = this.dialogService.open(
      requestRef,
      {},
      this.viewContainerRef,
    );
  }
  addMC(monitoringCompany: any) {
    if (monitoringCompany.key === 0) {
      this.openAddMonitoringCompany();
    }
    this.updateJobDetail({ monitoring_company_id: monitoringCompany?.id });
    this.dialogRef.close();
  }
  openAddMonitoringCompany() {
    if (this.mcInputValue?.length > 0) {
      this.spinnerService.show();
      this.clientService
        .createMonitoringCompany({
          company_name: String(this.mcInputValue),
        })
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.spinnerService.hide();
            this.addMC(response?.data);
          } else {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              errorMessage: response['message'],
              successMessage: '',
            });
          }
        });
    } else {
      this.toasterService.setMessage({
        errorMessage: "Monitoring Company value can't be empty",
        successMessage: '',
      });
    }
  }
  onOpenFile(file: any) {
    if (file?.extension === '.pdf') {
      this.downloadFile(file);
    } else {
      this.dialogRef = this.dialogService.open(MediaPreviewComponent, {
        data: { mediaSrc: file?.file_url },
      });
    }
  }

  downloadFile(file: any) {
    const a = document.createElement('a');
    a.href = file?.file_url;
    a.download = `${file?.name}${file?.extension}`;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  updateJobId() {
    this.updateJobDetail({ external_job_id: this.externalNewJobId });
  }

  modifyExternalJobId(template: any) {
    this.externalNewJobId = this.jobDetailData?.ext_job_id;
    this.externalOldJobId = this.jobDetailData?.ext_job_id;
    this.dialogRef = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
    this.dialogRef.afterClosed().subscribe(() => {});
  }

  getFileSrc(file: File): SafeUrl {
    let url = URL.createObjectURL(file);
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  clearIntervalTimeoutFunction() {
    if (this.onsiteTimeOutFn) {
      clearTimeout(this.onsiteTimeOutFn);
    }
  }

  resyncTimer() {
    this.getOnsiteTimerValue();
    this.onsiteTimeOutFn = setTimeout(() => {
      this.resyncTimer();
    }, 1000 * 180);
  }

  startOnsiteCountUp() {
    this.clearIntervalTimeoutFunction();
    this.onsiteTime = this.getOnsiteTime();
    this.ngZone.run(() => {
      this.resyncTimer();
      this.onsiteIntervalFn = setInterval(() => {
        this.getOnsiteTimerValue();
      }, 1000);
    });
  }
  getOnsiteTimerValue() {
    if (!this.onsiteTime) {
      this.onsiteTime = this.getOnsiteTime();
    }
    let diffInTime = new Date().getTime() - this.onsiteTime;
    let seconds = Math.floor(diffInTime / 1000);
    let hours = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds % 3600) / 60);
    let remainingSeconds = seconds % 60;
    this.onsiteTimer = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(
      remainingSeconds,
    )}`;
  }
  getOnsiteTime() {
    let onsiteTime = new Date();
    const lastCancel = this.jobDetailData?.history
      .filter(
        (item: any) => item?.event_action == 1 && item?.status_identity == 4,
      )
      .sort(
        (a: any, b: any) =>
          new Date(b?.updated_at).getTime() - new Date(a?.updated_at).getTime(),
      );
    if (lastCancel?.length)
      return new Date(lastCancel[0]?.updated_at).getTime();

    return new Date(onsiteTime).getTime();
  }

  pad(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  getTimeDifference() {
    [this.jobStartDateTime, this.jobEndDateTime] = getStartEndDateTime(
      this.jobDetailData?.roster_scheduler,
      this.jobDetailData?.schedule_event_date,
    );

    if (this.jobDetailData?.assignee?.length) {
      const jobAssignee = this.jobDetailData?.assignee?.[0];
      this.requiresAcceptance =
        jobAssignee?.id === this.subscriberUserId &&
        jobAssignee?.acceptance_status == 2 &&
        this.jobDetailData?.service_type?.requires_acceptance;
      if (jobAssignee?.id === this.subscriberUserId) {
        let requiresClockInOut = this.dataCheckService.requireClockInOut();
        if (this.jobDetailData?.roster_scheduler?.repeat_type) {
          requiresClockInOut = this.jobDetailData
            ?.user_current_clock_status_for_shift
            ? requiresClockInOut
            : false;
          if (requiresClockInOut) {
            this.shiftClockInOutParms.hasUserClockedIn =
              !!this.jobDetailData?.user_current_clock_status_for_shift?.[0];

            this.shiftClockInOutParms.hasUserClockedOut =
              !!this.jobDetailData?.user_current_clock_status_for_shift?.[1];
          }

          this.shiftClockInOutParms = {
            ...this.shiftClockInOutParms,

            requiresClockInOut: requiresClockInOut,
            jobId: this.jobDetailData?.id,
            shiftStartTime: this.jobStartDateTime,
            shiftEndTime: this.jobEndDateTime,
          };
        }
      }
    }

    let startTime = new Date(this.jobStartDateTime);
    let endTime = new Date(this.jobEndDateTime);

    this.scheduleDuration = this.getTimeDiff(startTime, endTime);
    startTime = new Date(this.jobStartDateTime);
    endTime = new Date(this.jobEndDateTime);

    this.scheduleCheckFn(startTime, endTime);
  }

  getTimeDiff(startTime: any, endTime: any) {
    const maxStartTime = Math.max(startTime?.getTime(), new Date().getTime());
    const diffValue = endTime?.getTime() - maxStartTime;
    var minuteDifference = diffValue / (1000 * 60);
    [this.intervalData, this.welfareReminderDict] =
      getWelfareCheckInterval(minuteDifference);

    let diffInTime = endTime?.getTime() - startTime?.getTime();

    if (!diffInTime) return '00:00';
    let seconds = Math.floor(diffInTime / 1000);
    let hours = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds % 3600) / 60);

    return `${this.pad(hours)}:${this.pad(minutes)}`;
  }
  openIntervalCheckTemplate(template: any) {
    if (
      (this.isAdmin || this.isDispatchUser) &&
      this.intervalData?.length &&
      !this.offlineMode &&
      ![1, 2, 3, 9, 10, 11, 12, 13].includes(
        this.jobDetailData?.status?.status_identity?.value,
      )
    ) {
      this.dialogRef = this.dialogService.open(
        template,
        {},
        this.viewContainerRef,
      );
    }
  }
  updateInterval(interval: Number) {
    this.updateJobDetail({ interval_check: interval });
  }
  formatDateWithoutTime = (date: any) => {
    date.setHours(0, 0, 0, 0);
    return date.getTime();
  };
  scheduleCheckFn(startDatetime: any, endDateTime: any) {
    const isAdminORDispatcher = this.isAdmin || this.isDispatchUser;

    const subscriberSettings = this.dataCheckService.getSubscriberSettings();

    const shiftAutoAccept = subscriberSettings?.shift_auto_accept || false;

    this.canDeclineJob =
      !isAdminORDispatcher &&
      new Date().getTime() + 3600000 * 24 < new Date(startDatetime).getTime() &&
      !this.jobDetailData?.run_sheet?.id &&
      !shiftAutoAccept;

    // guards can Decline Shift if its after 24 hrs https://app.shortcut.com/sendem/story/5680/guards-can-decline-shifts
    this.scheduleCheck =
      !this.jobDetailData?.roster_scheduler?.repeat_type || isAdminORDispatcher;
    if (!this.scheduleCheck) {
      const today = this.formatDateWithoutTime(new Date());

      this.ngZone.run(() => {
        this.scheduleCheck =
          this.formatDateWithoutTime(startDatetime) <= today &&
          this.formatDateWithoutTime(endDateTime) >= today;
      });
    }
  }
  isPastScheduleCheck() {
    const endDateTime = new Date(
      (this.jobDetailData?.schedule_event_date ||
        this.jobDetailData.roster_scheduler.end_day) +
        ' ' +
        this.jobDetailData.roster_scheduler.end_time,
    );
    if (
      this.jobDetailData.roster_scheduler?.start_time >
        this.jobDetailData.roster_scheduler?.end_time &&
      this.jobDetailData?.roster_scheduler?.repeat_type != 'once'
    ) {
      endDateTime.setDate(endDateTime.getDate() + 1);
    }

    endDateTime.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    this.isCurrentORFutureSchedule = endDateTime.getTime() >= today.getTime();
  }

  sheduleIfChecks() {
    this.isPastScheduleCheck();
    const now = new Date();

    const startTime = new Date(
      this.jobDetailData.roster_scheduler.start_day +
        ' ' +
        this.jobDetailData.roster_scheduler.start_time,
    );
    const endTime = new Date(
      this.jobDetailData.roster_scheduler.end_day +
        ' ' +
        this.jobDetailData.roster_scheduler.end_time,
    );

    const canUpdateSchedule =
      endTime.getTime() > now.getTime() &&
      (!this.jobDetailData?.schedule_event_date ||
        this.formatDateWithoutTime(
          new Date(this.jobDetailData?.schedule_event_date),
        ) >= this.formatDateWithoutTime(now));

    if (!(this.isAdmin || this.isDispatchUser)) {
      this.canScheduleBeUpdated = false;
      this.showWelfareItem = canUpdateSchedule;

      return;
    }

    this.canScheduleBeUpdated = canUpdateSchedule;

    this.showWelfareItem = this.canScheduleBeUpdated;

    this.hasScheduleStarted = startTime.getTime() < new Date().getTime();
  }
  startEndTimeComparison() {
    let startTime = new Date(
      this.schedulerForm.value.start_day +
        ' ' +
        this.schedulerForm.value.start_time,
    );
    let endTime = new Date(
      this.schedulerForm.value.start_day +
        ' ' +
        this.schedulerForm.value.end_time,
    );

    return startTime.getTime() > endTime.getTime();
  }
  openInTransitTemplate(template: any) {
    if (this.jobDetailData?.eta) {
      const diffMs = Math.floor(
        Math.abs(
          new Date(this.jobDetailData?.eta).getTime() - new Date().getTime(),
        ) /
          (1000 * 60),
      );
      this.etaTimeinMinutes = diffMs > 0 ? diffMs : 0;
    }
    this.dialogRef = this.dialogService.open(
      template,
      {},
      this.viewContainerRef,
    );
    this.dialogRef.afterClosed().subscribe((value: any) => {
      if (value !== false && typeof value === 'string') {
        let body: any = {
          change_eta: 1,
          eta: this.checkAndModifyETA(value),
          reason: this.etaChangeReason,
        };

        this.updateJobDetail(body);
      }
    });
  }
  openReceivedAtTemplate(template: any) {
    this.jobReceivedAtDateTime = getFormattedDateTime(
      this.jobDetailData?.job_received_at || this.jobDetailData?.created_date,
    );
    this.dialogRef = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }
  openFenceAlertTemplate(template: any, seeRadiusOnly = false) {
    this.dialogService.open(
      template,
      { data: { seeRadiusOnly: seeRadiusOnly } },
      this.viewContainerRef,
    );
  }
  updateMinDistance(event: any) {
    this.geoAlertDistance = event;
  }
  updateGeoFenceAlert() {
    let body: any = {
      change_geofence: 1,
      geofence_distance: this.geoAlertDistance,
    };

    this.updateJobDetail(body);
  }

  openScheduleTemplate() {
    if (!(this.isAdmin || this.isDispatchUser)) return;
    if (!this.jobDetailData?.roster_scheduler?.id) return;

    const dialogRef = this.dialogService.open(ChangeScheduleComponent, {
      data: {
        roster_scheduler: this.jobDetailData?.roster_scheduler,
        schedule_event_date: this.jobDetailData?.schedule_event_date,
      },
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.schedulerForm.patchValue(res);
        this.updateSchedule();
      }
    });
  }

  formatScheduleForm(form: any) {
    form.value.start_day =
      form.value.start_day == ''
        ? ''
        : formatDate(form.value.start_day, 'yyyy-MM-dd', 'en');
    form.value.end_day =
      form.value.end_day == null
        ? null
        : formatDate(form.value.end_day, 'yyyy-MM-dd', 'en');
    let timezoneOffset = new Date();
    return {
      time_offset: timezoneOffset.getTimezoneOffset(),
      ...form.value,
    };
  }
  updateSchedule() {
    this.spinnerService.show();

    let data: any = {
      job_id: this.jobDetailData?.id,
      time_offset: new Date().getTimezoneOffset(),
      ...this.formatScheduleForm(this.schedulerForm),
    };
    this.rsService
      .updateRosterShifts(this.jobDetailData?.id, data, {
        update_individual_shift: 1,
      })
      .then((response: any) => {
        if (response?.status === 'success') {
          this.toasterService.setMessage({
            successMessage: 'Shift Updated',
            errorMessage: '',
          });
          this.getJobDetails();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }

        this.spinnerService.hide();
      });
  }
  filterStatuses(statusArray: any, idArrays: any) {
    return statusArray?.filter((status: any) => {
      for (const idArray of idArrays) {
        if (idArray && idArray.includes(status.status.id)) {
          return true;
        }
      }

      return false;
    });
  }

  calculateFixedBottomHeight() {
    // Get the bottom-section-fixed element by ID

    const bottomSectionFixed = document.getElementById('bottom-section-fixed');

    if (bottomSectionFixed) {
      this.bottomSectionFixedHeight =
        bottomSectionFixed.offsetHeight.toString() + 'px';
    }
    setTimeout(() => {
      // added this becuase review status is taking some time to load
      const bottomSectionFixed = document.getElementById(
        'bottom-section-fixed',
      );

      if (bottomSectionFixed) {
        this.bottomSectionFixedHeight =
          bottomSectionFixed.offsetHeight.toString() + 'px';
      }
    }, 1000);
  }

  changeUserProvidedTime(event: any) {
    const selectedTime = new Date(event?.target.value);
    this.jobStatusTimeChange.valid = false;
    if (selectedTime.getTime() > new Date().getTime()) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'Cannot set future date',
      });
    } else if (
      selectedTime.getTime() <
      new Date(this.jobStatusTimeChange?.created_at).getTime()
    ) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'Date must be greater than job created date',
      });
    } else {
      this.jobStatusTimeChange.valid = true;
      this.dateTimeValue = getFormattedDateTime(selectedTime);
    }
  }
  async getAllIndexedDbItems() {
    try {
      const data = await gTDB.gtSavedData.toArray();

      return data;
    } catch (error) {
      return [];
    }
  }

  updateAssignee() {
    this.jobDetailData?.assignee?.forEach((assignee: any) => {
      this.updateJobDetail({ remove_assignee: assignee?.id }, false);
    });
    if (this.selectedAssignee?.id)
      this.updateJobDetail({ new_assignee: this.selectedAssignee?.id }, false);

    this.toasterService.setMessage({
      successMessage: 'Assignee Updated!',
      errorMessage: '',
    });

    this.dialogRef?.close();
  }

  updateEtaTime(eta: any, source: string) {
    let etaSelectedTime = new Date();
    switch (source) {
      case 'button':
        this.etaTimeinMinutes = eta?.value || 0;
        etaSelectedTime.setMinutes(
          etaSelectedTime.getMinutes() + this.etaTimeinMinutes,
        );
        break;
      case 'number':
        const input: any = eta?.target as HTMLInputElement;
        this.etaTimeinMinutes = Number(eta?.target?.value) || 0;
        input.value = this.etaTimeinMinutes;
        etaSelectedTime.setMinutes(
          etaSelectedTime.getMinutes() + this.etaTimeinMinutes,
        );

        break;
      case 'date':
        etaSelectedTime = eta?.target?.value
          ? new Date(eta?.target?.value)
          : new Date();
        const diffMs = Math.floor(
          Math.abs(etaSelectedTime.getTime() - new Date().getTime()) /
            (1000 * 60),
        );
        this.etaTimeinMinutes = diffMs;

        break;
    }

    this.etaValue = getFormattedDateTime(etaSelectedTime);
  }
  clearAndFocusTextBox(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 100);
  }
  getDeviceID() {
    if (!this.loggedInDeviceID) {
      this.loggedInDeviceID = this.deviceInfoService.getUniqueDeviceID();
    }
  }
  async deleteRestoreUserUpdate(event: any) {
    this.deviceInfoService
      .getGpsCoordinates()
      .then((gps: any) => (this.currentUserLocation = gps));

    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: event?.type === 'delete' ? 'Delete Event' : 'Restore Event',
        message:
          event?.type === 'delete'
            ? `Are you sure you want to delete this event?`
            : 'Are you sure you want to restore this event?',
      },
    });
    const dRes = await firstValueFrom(dialogRef.afterClosed());
    if (dRes) {
      this.spinnerService.show();
      let fileData: FormData = new FormData();
      fileData.append('id', event?.event?.id);
      fileData.append(
        event?.type === 'delete' ? 'delete_update' : 'restore_update',
        '1',
      );

      this.callUploadApi(fileData, {});
    }
  }

  isItemNotShownInReport(eventData: any) {
    return ![0, 1, 7, 8, 19, 20].includes(eventData?.event_action);
  }

  getResponseTypes(params?: any) {
    this.clientService.fetchResponseTypeList(params).subscribe((res: any) => {
      if (res['status'] == 'success') {
        this.responseTypeList = res['data'];

        this.initalResponseTypeList = JSON.parse(JSON.stringify(res?.data));
      }
    });
  }
  openUpdateResponseTypeTemplate(template: TemplateRef<any>) {
    this.getResponseTypes();
    this.previousResponseTypeValue = this.jobDetailData?.response_type?.name;

    this.dialogRef = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }
  onSelectResponseType(event: any) {
    if (event?.key === 0) {
      this.openAddResponseTypeForm();
    }
    if (event?.id) {
      let body: any = {
        response_type_id: event?.id,
      };

      this.updateJobDetail(body);
    }
  }
  onSearchResponseType(event: any) {
    this.previousResponseTypeValue = event.target.value;
    if (event.target.value.length) {
      this.responseTypeList = this.initalResponseTypeList?.filter((type: any) =>
        type?.name?.toLowerCase()?.includes(event.target.value?.toLowerCase()),
      );
    } else {
      this.responseTypeList = this.initalResponseTypeList;
    }
  }

  openAddResponseTypeForm() {
    if (this.previousResponseTypeValue.length > 0) {
      this.spinnerService.show();
      this.clientService
        .createResponseType({
          name: String(this.previousResponseTypeValue),
        })
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.spinnerService.hide();
            this.onSelectResponseType(response?.data);
            this.getResponseTypes();
          } else {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              errorMessage: response['message'],
              successMessage: '',
            });
          }
        });
    } else {
      this.toasterService.setMessage({
        errorMessage: "Response Type Name can't be empty",
        successMessage: '',
      });
    }
  }
  editField(field: string) {
    if (field == 'rt') {
      this.previousResponseTypeValue = null;
      this.responseTypeList = this.initalResponseTypeList;
      this.shiftFocus('rtId');
    }
    if (field == 'st') {
      this.previousServiceTypeValue = null;
      this.serviceTypeListData = this.initalServiceTypeListData;
      this.shiftFocus('stId');
    }
    if (field == 'mc') {
      this.mcInputValue = null;
      this.getMonitoringCompanyList();
      this.shiftFocus('mcId');
    }
  }
  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    });
  }
  openUpdateServiceTypeTemplate(template: TemplateRef<any>) {
    this.getServiceTypes();
    this.previousServiceTypeValue = this.jobDetailData?.job_service_type?.name;

    this.dialogRef = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }
  onSTSearch(event: any) {
    this.previousServiceTypeValue = event.target.value;

    if (event.target.value.length) {
      this.serviceTypeListData = this.initalServiceTypeListData?.filter(
        (type: any) =>
          type?.name
            ?.toLowerCase()
            ?.includes(event.target.value?.toLowerCase()),
      );
    } else {
      this.serviceTypeListData = this.initalServiceTypeListData;
    }
  }

  getServiceTypes(params?: any) {
    this.clientService.fetchServiceTypeList(params).subscribe((res: any) => {
      if (res['status'] == 'success') {
        this.serviceTypeListData = res['data'];

        this.initalServiceTypeListData = JSON.parse(JSON.stringify(res?.data));
      }
    });
  }
  onServiceTypeSelect(sType: any) {
    if (sType.key === 0) {
      this.openAddServiceType();
    }
    if (sType?.id) {
      let body: any = {
        service_type_id: sType?.id,
      };

      this.updateJobDetail(body);
    }
  }
  openAddServiceType() {
    if (this.previousServiceTypeValue.length > 0) {
      this.spinnerService.show();
      this.clientService
        .createServiceType({ name: String(this.previousServiceTypeValue) })
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.spinnerService.hide();
            this.onServiceTypeSelect(response?.data);

            this.getServiceTypes();
          } else {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              errorMessage: response['message'],
              successMessage: '',
            });
          }
        });
    } else {
      this.toasterService.setMessage({
        errorMessage: "Service Type value can't be empty",
        successMessage: '',
      });
    }
  }
  declineJob() {
    this.updateJobDetail({
      decline_job: this.subscriberUserId,
      decline_reason: this.declineReason,
    });
  }
  openJobDeclineTemplate(template: any) {
    this.declineReason = '';
    this.dialogRef = this.dialogService.open(
      template,
      {},
      this.viewContainerRef,
    );
  }

  async checkValidCredentialsForAssignee(assigneeId: string) {
    return new Promise((resovle) => {
      this.spinnerService.show('Checking Guard Credentials');

      const stateCode =
        this.jobDetailData?.sites?.[0]?.address?.state_code?.toLowerCase();
      const stateName =
        this.jobDetailData?.sites?.[0]?.address?.state_name?.toLowerCase();

      let stateArrays = [];

      if (stateCode)
        stateArrays.push(stateCode?.toLowerCase(), stateCode?.toUpperCase());
      if (stateName)
        stateArrays.push(stateName?.toLowerCase(), stateName?.toUpperCase());
      stateArrays = [...new Set(stateArrays)];
      if (stateArrays?.length) {
        this.userService
          .getUserById(assigneeId, {
            valid_cred_check: 1,
            states: JSON.stringify(stateArrays),
          })
          .subscribe((response: any) => {
            resovle(response?.data || false);
            this.spinnerService.hide();
          });
      } else {
        resovle(true);
      }
    });
  }

  async fetchJobHistory(showSpinner = true) {
    if (showSpinner)
      this.spinnerService.show('Fetching latest data from server');
    const response: any = await lastValueFrom(
      this.jobService.getJobById(this.jobDetailData?.id, { get_history: 1 }),
    );
    this.spinnerService.hide();

    if (response['status'] == 'success') {
      this.spinnerService.hide();
      this.jobHistoryData = JSON.parse(
        JSON.stringify(response?.history?.reverse()),
      );
      this.loggedInUpdatesSet.clear();
      this.jobDetailData.check_list_tasks = JSON.parse(
        JSON.stringify(response?.check_list_tasks || []),
      );
      this.formatCachedList();
    }
    return true;
  }
  async retryUpdate(indexDbId: any) {
    const apiResponseDict: any =
      (await gTDB.userData.get('apiResponseDict')) || {};
    delete apiResponseDict[indexDbId];
    await gTDB.userData.put(apiResponseDict, 'apiResponseDict');

    this.syncData();
    setTimeout(() => {
      this.fetchJobHistory();
    }, 50);

    setTimeout(() => {
      this.formatCachedList();
    }, 500);
    setTimeout(() => {
      this.appService.removeToolTips();
    }, 2000);
  }
  syncData() {
    this.pageService.miscSubjectParam.next({ syncData: true });

    this.syncInProgress = true;
  }
  retrySendingUpdate() {
    if (this.offlineMode) {
      this.showOfflineMessage();
    } else {
      this.syncData();
      this.fetchJobHistory();
    }
    setTimeout(() => {
      this.appService.removeToolTips();
    }, 2000);
  }

  openSealInfoTemplate(template: any, modifyDict = false) {
    this.sealInfo = this.jobDetailData?.seal_info;
    if (modifyDict)
      this.sealInfo?.site_sealed
        ? (this.sealInfo = { internal_check: true })
        : (this.sealInfo = { internal_check: true, site_sealed: true });

    this.dialogRef = this.dialogService.open(
      template,
      { data: modifyDict },
      this.viewContainerRef,
    );
  }
  formatReceivedAtDatetime(event: any) {
    if (event.target.value) {
      this.jobReceivedAtDateTime = event.target.value;
    } else {
      this.jobReceivedAtDateTime = getFormattedDateTime();
    }
  }
  updateJobReceivedTime(jobReceivedAtDateTime: any) {
    this.updateJobDetail({ job_received_at: new Date(jobReceivedAtDateTime) });
  }

  async isUpdateNearSite() {
    //https://app.shortcut.com/sendem/story/11014/clock-in-clock-out-events-must-take-place-within-100m-of-site

    return new Promise(async (resolve) => {
      this.spinnerService.show('Checking your location');
      this.currentUserLocation =
        await this.deviceInfoService.getGpsCoordinates();
      const siteDistance: any =
        getDistanceUsingHaversine(
          this.currentUserLocation?.lat,
          this.jobDetailData?.sites?.[0]?.address?.latitude,
          this.currentUserLocation?.lon,
          this.jobDetailData?.sites?.[0]?.address?.longitude,
        ) || 0;
      this.spinnerService.hide();
      resolve(siteDistance > this.siteUpdateWarningDistance / 1000);
    });
  }
  async openSafetyPrompterComponent(promptData: any) {
    // this is for prompts tied to clock in
    const promptInfo = promptData?.[0];

    const dialogRef = this.dialogService.open(PrompterComponent, {
      data: { promptData: promptInfo?.prompts },
    });
    const value = await firstValueFrom(dialogRef.afterClosed());
    if (!value?.length) return false;

    this.spinnerService.show();

    let fileData: FormData = new FormData();

    fileData.append('update_prompt', '1');
    fileData.append('safety_prompt', '1'); // TODO: make this conditional when adding prompts for responses.

    fileData.append('user_prompt_id', promptInfo?.id);
    fileData.append(
      'prompt_data',
      JSON.stringify([
        {
          data: value,
          prompt_data: {
            id: promptInfo?.id,
            name: promptInfo?.note,
          },
        },
      ]),
    );
    if (this.jobDetailData?.run_sheet)
      fileData.append(
        'runSheetDetails',
        JSON.stringify({
          name: this.jobDetailData?.run_sheet?.name,
        }),
      );

    this.callUploadApi(fileData, {}, 'Marking Complete - Please Wait');

    return true;
  }
  async openCheckListMarkCompleteTemplate(template: any, task: any) {
    if (this.itemsNotInServer?.length) this.syncData();

    if ([4, 5].includes(this.jobDetailData?.status?.status_identity?.value)) {
      // has onsite status atleast
      const isLastItem =
        this.jobDetailData?.check_list_tasks?.length - 1 ===
          this.completedTaskCount &&
        this.jobDetailData?.status?.status_identity?.value == 4;
      task['isLastItem'] = isLastItem;

      const offsiteStatus = this.availableStatusesListData?.find(
        (s: any) => s?.status?.status_identity?.value === 5,
      );
      const isUserPromptTask =
        task?.prompt?.id && task?.prompt?.prompts?.length;
      let dialogRef: any;

      if (isUserPromptTask) {
        dialogRef = this.dialogService.open(PrompterComponent, {
          data: { promptData: task?.prompt?.prompts },
        });
      } else {
        dialogRef = this.dialogService.open(
          template,
          {
            data: task,
          },
          this.viewContainerRef,
        );
      }
      const dRes: any = await firstValueFrom(dialogRef.afterClosed());

      const check = isUserPromptTask ? dRes?.length : dRes?.id;

      if (!check) return;
      if (isLastItem && offsiteStatus?.status?.id) {
        this.spinnerService.show('Updating Status');
        let reqBody: any = {
          user_provided_timestamp: new Date(),
          job_status_id: offsiteStatus?.status?.id,
          run_sheet_id: this.jobDetailData?.run_sheet?.id,
          mark_complete: 1,
        };
        if (isUserPromptTask) {
          reqBody = {
            ...reqBody,
            user_prompt_id: task?.prompt?.id,
            check_list_id: task?.id,
            prompt_data: JSON.stringify([
              {
                data: dRes,
                prompt_data: {
                  id: task?.prompt?.id,
                  name: task?.note,
                },
              },
            ]),
          };
        } else {
          reqBody = {
            ...reqBody,
            check_list_id: dRes?.id,

            comment: dRes?.newComment || null,
          };
        }
        this.updateJobDetail(reqBody);
      } else {
        let fileData: FormData = new FormData();
        if (dRes?.newComment) {
          fileData.append('comment', dRes?.newComment);
        }

        fileData.append('mark_complete', '1');
        fileData.append('run_sheet_id', this.jobDetailData?.run_sheet?.id);
        fileData.append(
          'runSheetDetails',
          JSON.stringify({
            name: this.jobDetailData?.run_sheet?.name,
          }),
        );
        if (isUserPromptTask) {
          fileData.append('check_list_id', task?.id);
          fileData.append('user_prompt_id', task?.prompt?.id);
          fileData.append(
            'prompt_data',
            JSON.stringify([
              {
                data: dRes,
                prompt_data: {
                  id: task?.prompt?.id,
                  name: task?.note,
                },
              },
            ]),
          );
        } else {
          fileData.append('check_list_id', dRes?.id);
        }
        this.callUploadApi(fileData, {}, 'Marking Complete - Please Wait');
      }
    } else {
      const onsiteStatus = this.availableStatusesListData?.find(
        (s: any) => s?.status?.status_identity?.value === 4,
      );
      if (!onsiteStatus?.status?.id) return;

      const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
        data: {
          title: '',
          message:
            'You must be onsite to complete tasks.\n\nAre you currently onsite?',
          btn1Detail: { text: 'No' },
          btn2Detail: { text: 'Yes' },
        },
      });
      dialogRef.afterClosed().subscribe((dialogResponse) => {
        if (dialogResponse === true) {
          this.spinnerService.show('Updating Status');
          this.updateJobDetail({
            user_provided_timestamp: new Date(),
            job_status_id: onsiteStatus?.status?.id,
          });
        }
      });
    }
  }
  formatCheckPointScanData(response: any) {
    this.showUpdateFutureShifts = response?.future_schedule_exists || false;
    this.jobCheckpointListData = response?.data?.checkpoint_list || [];
    this.scannedCheckpointCount = response?.data?.scanned_count || 0;
    this.filterPatrolData = { checkpoint: [], company: [], site: [] };
    this.hasQRCheckpoints = false;
    this.hasNFCheckpoints = false;
    this.jobCheckpointListData?.forEach((checkpoint: any) => {
      if (!this.filterPatrolData.checkpoint.includes(checkpoint?.id)) {
        this.filterPatrolData.checkpoint.push(checkpoint?.id);
      }
      if (checkpoint?.site_id) {
        if (!this.filterPatrolData.site.includes(checkpoint?.site_id)) {
          this.filterPatrolData.site.push(checkpoint?.site_id);
        }
      } else {
        if (!this.filterPatrolData.company.includes(checkpoint?.company_id)) {
          this.filterPatrolData.company.push(checkpoint?.company_id);
        }
      }

      if (checkpoint?.qr_code) {
        if (checkpoint?.is_nfc_code) {
          this.hasNFCheckpoints = true;
        } else {
          this.hasQRCheckpoints = true;
        }
      }
    });
    this.updateJobDetailsToClient(response);
  }
  getCheckPointScans() {
    if (!this.jobDetailData?.id) return;
    if (this.jobDetailData?.service_type?.type_identity !== 6) return;
    if (!this.jobDetailData?.run_sheet?.id) return;

    this.jobService
      .getJobById(this.jobDetailData?.id, {
        get_cp_scan_info: 1,
        site_id: this.jobDetailData.sites?.[0]?.id,
      })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.formatCheckPointScanData(response);
        }
      });
  }
  requireSafetyCheck() {
    if (this.shiftClockInOutParms?.hasUserClockedIn) return [];
    const completedPrompts = new Set(
      this.jobDetailData?.history?.flatMap((item: any) =>
        item?.prompts?.map((prompt: any) => prompt?.prompt_data?.id),
      ),
    );

    return (this.jobDetailData?.user_prompts?.safety_prompts || [])?.filter(
      (item: any) => !completedPrompts.has(item?.id),
    );
  }
  async onClockInOutUser(updateStatus?: any) {
    const safetyPrompts = this.requireSafetyCheck();

    if (safetyPrompts?.length) {
      const response = await this.openSafetyPrompterComponent(safetyPrompts);

      if (!response) return;
    }

    const dialogRef = this.dialogService.open(
      ClockInOutComponent,
      {
        data: {
          updateStatus: updateStatus,
          shiftClockInOutParms: this.shiftClockInOutParms,
        },
      },
      this.viewContainerRef,
    );
    const resValue = await firstValueFrom(dialogRef.afterClosed());

    if (resValue) {
      if (resValue?.data?.id) {
        this.jobDetailData = resValue?.data;
        this.formatData();
        return;
      }
      this.shiftClockInOutParms.hasUserClockedIn =
        !!resValue?.user_current_clock_status_for_shift?.[0];

      this.shiftClockInOutParms.hasUserClockedOut =
        !!resValue?.user_current_clock_status_for_shift?.[1];
      this.shiftClockInOutParms = {
        ...this.shiftClockInOutParms,
      };
    }
  }
  async onAddCheckpointsToRoute() {
    const dialogRef = this.dialogService.open(AddCheckpointRouteComponent, {
      data: {
        showUpdateFutureShifts: this.showUpdateFutureShifts,
        selectedCheckpoints: JSON.parse(
          JSON.stringify(this.jobCheckpointListData || []),
        ),
        cpSiteFilter: this.jobDetailData?.sites?.[0] || {},
      },
    });

    const res = await firstValueFrom(dialogRef.afterClosed());
    if (res?.selectedCheckpoints) {
      const reqBody: any = {
        update_checkpoints: 1,
        add_to_future_shifts: res?.updateFutureShifts,
        checkpoints: [
          ...res?.selectedCheckpoints?.map((checkpoint: any) => ({
            id: checkpoint?.id,
          })),
        ],
      };

      this.updateJobDetail(reqBody);
    }
  }
  async openScanCPTemplate() {
    const dialogRef = this.dialogService.open(
      ScanCheckpointComponent,
      {
        data: {
          jobId: this.jobDetailData?.id || '',
        },
      },
      this.viewContainerRef,
    );
    const res = await firstValueFrom(dialogRef?.afterClosed());

    if (res?.source == 'scanCheckPoint') {
      this.updateTask = 'scanCheckPoint';
    } else if (res?.source == 'scanQrCode') {
      if (res?.data) this.getCheckPointScans();
    } else if (res?.source == 'scanNFCCode') {
      if (res?.data) this.getCheckPointScans();
    }
  }

  async openTemplate(
    template: TemplateRef<any>,
    updateItem: 'prompts' | 'addComment' | 'editComment',
    eventData?: any,
  ) {
    let data: any = {};
    if (updateItem == 'prompts') {
    }
    switch (updateItem) {
      case 'prompts':
        data = JSON.parse(JSON.stringify(eventData));
        break;

      case 'addComment':
        this.deviceInfoService
          .getGpsCoordinates()
          .then((gps: any) => (this.currentUserLocation = gps));

        data.newComment = '';
        break;

      case 'editComment':
        this.deviceInfoService
          .getGpsCoordinates()
          .then((gps: any) => (this.currentUserLocation = gps));

        data.newComment = eventData?.detail || '';
        data.previousComment = eventData?.detail || '';

        data = { ...eventData, ...data };

        break;
    }
    const dialogRef = this.dialogService.open(
      template,
      {
        data: data,
      },
      this.viewContainerRef,
    );
    const dRes = await firstValueFrom(dialogRef.afterClosed());
    if (!dRes) return;
    switch (updateItem) {
      case 'addComment':
      case 'editComment':
        if (!dRes?.id && !dRes?.newComment?.trim()) {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: 'Comment cannot be empty',
          });
          return;
        }

        this.spinnerService.show('Uploading Comment');
        let fileData: FormData = new FormData();
        fileData.append('comment', dRes?.newComment);

        if (dRes && dRes?.id) {
          fileData.append('id', dRes?.id);
          fileData.append('edit_comment', '1');
        }

        this.callUploadApi(fileData, {});

        break;
    }
  }
  modifyShiftPosition(template: any) {
    this.oldShiftPositionValue = this.jobDetailData?.position;
    this.newShiftPositionValue = this.jobDetailData?.position;
    this.dialogRef = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
    this.dialogRef.afterClosed().subscribe(() => {});
  }
}
